module.exports = __webpack_public_path__ + "static/media/ic_aadhaar_handy.7e42e9a5.svg";